import { Role } from '../graphql/generated';

import { RoleType, RoleTypes } from './permissions.types';

export const roleTypes: RoleTypes = {
  [Role.SuperAdmin]: RoleType.Admin,

  [Role.CentralWasteTeamAdmin]: RoleType.CentralTeam,
  [Role.CentralWasteTeamOperations]: RoleType.CentralTeam,
  [Role.CentralWasteTeamFinance]: RoleType.CentralTeam,

  [Role.Customer]: RoleType.Customer,
  [Role.CustomerApprover]: RoleType.Customer,
  [Role.CustomerExternal]: RoleType.Customer,
  [Role.CustomerExternalApprover]: RoleType.Customer,
  [Role.ContractController]: RoleType.Customer,

  [Role.Supplier]: RoleType.Supplier,
};
